import { ReactNode, useEffect, useState } from "react";
import Header from "./Templates/Header/Header";
import SideBar from "./Templates/Sidebar/Sidebar";
import Footer from "./Templates/Footer/Footer";
import Main from "./Templates/Main/Main";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import useRedux from "redux/useRedux";
import { fetchConfigurationData } from "redux/merchant";
import { OnboardingProvider } from "context/onboarding.context";
import OnboardingWelcome from "components/Onboarding/OnboardingWelcome";
import OnboardingTour from "components/Onboarding/OnboardingTour";

interface PrivateLayoutProps {
  children?: ReactNode;
}

export default function PrivateLayout({ children }: PrivateLayoutProps) {
  const {
    thunkDispatch,
    storeState: { Auth },
  } = useRedux();

  const navigate = useNavigate();

  const [sidebar, setSidebar] = useState(true);
  const [showBiteshipAlert, setShowBiteshipAlert] = useState(false);

  const handleSidebar = () => {
    setSidebar((prevValue) => {
      return !prevValue;
    });
  };

  // Set CSS variable for sidebar width so fixed sticky footer can align correctly
  useEffect(() => {
    const sidebarWidth = sidebar ? "250px" : "5rem";
    document.documentElement.style.setProperty("--app-sidebar-width", sidebarWidth);
  }, [sidebar]);

  useEffect(() => {
    const token = Auth?.data?.data?.token;
    const merchantId = Auth?.data?.data?.merchant?.id;

    if (token && merchantId) {
      thunkDispatch(fetchConfigurationData({ idBusiness: merchantId, token }))
        .unwrap()
        .then((res: any) => {
          if (res && res.data) {
            const { isBiteship, biteshipCouriers } = res.data;
            if (isBiteship === true && (!biteshipCouriers || biteshipCouriers.length === 0)) {
              setShowBiteshipAlert(true);
            }
          }
        })
        .catch((err) => {
          console.error("Failed to fetch configuration in PrivateLayout:", err);
        });
    }
  }, [thunkDispatch, Auth]);

  return (
    <OnboardingProvider>
      <Header sidebar={sidebar.toString()} handleSidebar={handleSidebar} />
      <SideBar sidebar={sidebar.toString()} />
      <Main sidebar={sidebar.toString()} />
      <Footer sidebar={sidebar.toString()} />

      {/* Onboarding UI */}
      {Auth?.data?.data?.roles?.[0] !== 'ROLE_SUPER_ADMIN' && (
        <>
          <OnboardingWelcome />
          <OnboardingTour />
        </>
      )}
    </OnboardingProvider>
  );
}
